(function() {
  function PlacesAutoComplete() {
    this.init = init;

    function init() {
      bindEvents();
    }

    function bindEvents() {
      var input = document.getElementById('id_city'),
          options = {
            types: ['(cities)']
          };

      new google.maps.places.Autocomplete(input, options);
    }
  }
  TSk.PlacesAutoComplete = PlacesAutoComplete;
})();

$(function() {
  var places_autocomplete = new TSk.PlacesAutoComplete();
  places_autocomplete.init();
});
